/*
 * Developer : Alexey Zakharov (alexey.zakharov@vectioneer.com)
 * All rights reserved. Copyright (c) 2015 - 2018 VECTIONEER.
 */

"use strict";

export const TreeNodeType = Object.freeze({
  ANY: 0,
  PARAMETER: 1,
  MODULE: 2,
});

export class TreeNode {
  constructor(name = "", type = TreeNodeType.ANY) {
    this.name = name;
    this.type = type;
    this.parent = null;
    this.info = null;
    this.children = [];
  }

  copy() {
    const cp = new TreeNode(this.name, this.type);
    cp.parent = this.parent;
    cp.info = this.info;
    cp.children = [];
    return cp;
  }

  flat() {
    let result = [];
    let filtered = this.children.filter((child) => {
      if (child.children.length > 0) {
        result = result.concat(child.flat());
        return false;
      }
      return true;
    });

    return result.concat(filtered);
  }

  filter(opt) {
    const depth = opt.depth >= 0 ? opt.depth : Infinity;
    const name = opt.name ? opt.name : "/*";
    const type = opt.type ? opt.type : TreeNodeType.ANY;

    const node = new TreeNode();
    const counter = 0;

    return this.__filter(node, name, type, depth, counter);
  }

  getName() {
    return this.name;
  }

  addChild(node) {
    let new_child;
    if (node instanceof TreeNode) {
      new_child = this.getChild(node.name);
      if (!new_child) {
        this.children.push(node.copy());
        this.children[this.children.length - 1].setParent(this);
        return this.children[this.children.length - 1];
      }
    }
    return new_child;
  }

  getChild(path) {
    const names = path.split("/");
    let node = this;
    names.forEach((name) => {
      if (node) {
        node = node.children.find((ch) => ch.name === name);
      }
    });
    return node;
  }

  setParent(parent) {
    this.parent = parent;
  }

  getParent() {
    return this.parent;
  }

  setInfo(info) {
    this.info = info;
  }

  getInfo() {
    return this.info;
  }

  setType(type) {
    this.type = type;
  }

  getType() {
    return this.type;
  }

  // internal
  __filter(node, name, type, depth, counter) {
    if (depth >= 0) {
      this.children.forEach((element) => {
        const pattern = RegExp(name, "i"); // case insensitive
        const found = element.name.match(pattern);
        if (found && (type === TreeNodeType.ANY || element.type === type)) {
          const branches = [];
          let el = element;
          for (let i = 0; i <= counter; i++) {
            branches.push(el);
            el = el.parent;
          }
          let added_node = node;
          branches.reverse().forEach((b) => {
            added_node = added_node.addChild(b);
          });
          element.__filter(added_node, name, type, depth - 1, counter + 1);
        } else {
          element.__filter(node, name, type, depth - 1, counter + 1);
        }
      });
    }
    return node;
  }
}
